import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {
  private _authData = new BehaviorSubject<any | null>(null);

  // Observable for components to subscribe to
  authData$: Observable<any | null> = this._authData.asObservable();

  // Store authData
  setAuthData(data: any): void {
    this._authData.next(data);
  }

  // Retrieve current value (synchronously)
  getAuthData(): any | null {
    return this._authData.value;
  }

  getRole(): string {
    return this.getAuthData()['https://sprintray.com/roles'] ?? null;
  }

  hasDoctorRole(): boolean {
    return this.getRole()?.toLowerCase()?.includes('doctor') ?? false;
  }

  hasPrintLabRole(): boolean {
    return this.getRole()?.toLowerCase()?.includes('printlab') ?? false;
  }

  isDoctor(): boolean {
    return this.getRole()?.toLowerCase() === 'doctor';
  }

  isPrintLab(): boolean {
    return this.getRole()?.toLowerCase() === 'printlab';
  }
}